import { useCenterNotificationStore } from "@src/shared/components/CenterNotification/model/store";
import { ServerEventDto } from "../../api/interfaces/serverEventDto";
import { hasSeenEvent, markEventSeen } from "../../lib/seenEvents";

export function handleAvailableAttemptsEvent(dto: ServerEventDto) {
  if (!dto.event_id) return;

  if (hasSeenEvent(dto.event_id)) return;

  useCenterNotificationStore.getState().openCenterAlert({
    message: dto.message,
    type: "success",
    actionLabel: "Начать пользоваться",
    actionHref: "/creating-search",
  });

  markEventSeen(dto.event_id);
}
